<template>
  <div class="goods-check ">
    <div class="relative">
      <el-tabs
        class="modify-el__tabs"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="item in panel"
          :label="item.label"
          :name="item.name"
          :key="item.name"
          lazy
        >
          <SearchComponent
            ref="search"
            @updateData="_updateData"
            :condition="condition"
            :routeName="$route.name"
          />
          <TableComponent
            ref="table"
            :tableData="tableData"
            :routeName="$route.name"
            @updateData="_updateData"
            :pagination="pagination"
          >
            <template #default="{jumpRoute,handleCheckResult}">
              <div class="table">
                <el-table
                  :data="tableData"
                  :height="553"
                  v-min-height
                  border
                  header-cell-class-name="theader-th__table"
                  :header-cell-style="{ background: 'transparent' }"
                  cell-class-name="tbody-td__table"
                  class="no-hover no-pad__bor"
                >
                  <el-table-column
                    label="商品标题"
                    align="center"
                    min-width="400"
                  >
                    <div slot-scope="scope">
                      <span class="top-bg" style="padding-left: 1rem">
                        企业名称：{{ scope.row.companyName }}
                      </span>
                      <div class="order-details">
                        <div class="box">
                          <el-image
                            :src="scope.row.imgUrl"
                            :preview-src-list="[scope.row.imgUrl]"
                            class="goods-img"
                          >
                            <div slot="error" class="image-slot">
                              <i class="iconfont icon-tupian" />
                            </div>
                          </el-image>
                          <div class="caption">
                            <p class="ellipses">
                              <el-tooltip
                                effect="light"
                                placement="bottom-start"
                                :content="scope.row.cnName"
                              >
                                <span class="goods-name">
                                  {{ scope.row.cnName }}</span
                                >
                              </el-tooltip>
                            </p>
                            <p class="ellipses">
                              <el-tooltip
                                effect="light"
                                placement="bottom-start"
                                :content="scope.row.enName"
                              >
                                <span class="goods-name">
                                  {{ scope.row.enName }}</span
                                >
                              </el-tooltip>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-table-column>
                  <el-table-column
                    prop="stock"
                    align="center"
                    label="库存"
                    min-width="180"
                  >
                    <template slot-scope="scope">
                      <span class="top-bg" />
                      <div class="order-details">
                        {{ scope.row.stock }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="商品类型"
                    min-width="180"
                  >
                    <template slot-scope="scope">
                      <span class="top-bg" />
                      <div class="order-details">
                        {{ scope.row.type | formatGoodsType }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="违规说明"
                    align="center"
                    v-if="activeName === '3'"
                    min-width="360"
                  >
                    <template slot-scope="scope">
                      <span class="top-bg" />
                      <div class="order-details violating-goods">
                        <el-tooltip
                          v-for="item in scope.row.illegalList"
                          :key="item.illegalType"
                          effect="light"
                          placement="bottom-start"
                          :content="item.reason"
                        >
                          <p class="box" :class="`color${item.illegalType}`">
                            <el-input v-model="item.reason" disabled>
                              <template slot="prepend">
                                {{ item.illegalType }}
                              </template>
                            </el-input>
                          </p>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="提交时间"
                    min-width="180"
                  >
                    <template slot-scope="scope">
                      <span class="top-bg" />
                      <div class="order-details">
                        {{ scope.row.time }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    min-width="180"
                    label="操作"
                    fixed="right"
                    class-name="visible"
                  >
                    <template slot-scope="scope">
                      <span class="top-bg" />
                      <div class="order-details">
                        <el-button
                          v-permission:details="$route.meta.permission"
                          class="iconfont icon-chakanxiangqing d5"
                          round
                          @click="jumpRoute(scope.row)"
                          size="36"
                        />
                        <el-button
                          v-permission:check="$route.meta.permission"
                          class="iconfont icon-shenhe sub-color"
                          round
                          @click="handleCheckResult(scope.row)"
                          size="36"
                          v-if="activeName === '1'"
                        />
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </TableComponent>
        </el-tab-pane>
      </el-tabs>
      <Review ref="pop" funcName="getGoodsCheck" />
    </div>
  </div>
</template>
<script>
import SearchComponent from '../Components/SearchComponent'
import TableComponent from '../Components/TableComponent'
import updateData from 'mixins/updateData'
import tabsIndex from 'mixins/tabsIndex'
import Review from 'components/Pop/Review/'

export default {
  name: 'goodsCheck',
  mixins: [tabsIndex, updateData],
  components: {
    SearchComponent,
    TableComponent,
    Review
  },
  data() {
    this.panel = [
      {
        label: '已审核',
        name: '2'
      },
      {
        label: '待审核',
        name: '1'
      },
      {
        label: '审核不通过',
        name: '3'
      }
    ]
    this.keyMap = {
      goods_list: {
        name: 'tableData',
        add_time: 'time',
        goods_en: 'enName',
        enterprise_name: 'companyName',
        goods_id: 'id',
        goods_merchant_id: 'goodsMerchantId',
        goods_image: 'imgUrl',
        goods_name: 'cnName',
        goods_storage: 'stock',
        goods_type: 'type',
        violation_instructions: 'illegalList',
        violation_type: 'illegalType',
        violation_reason: 'reason'
      }
    }
    return {
      activeName: '2',
      condition: {},
      tableData: [],
      pagination: {
        currentPage: 1,
        pageTotal: 19,
        recordTotal: 80
      }
    }
  },
  created() {
    this._getMerchantGoodsList({
      curpage: 1,
      audit_status: this.activeName
    })
  },
  methods: {
    /**
     * 标签页切换
     * @param tab
     * @param event
     */
    handleClick(tab, event) {
      this.tableData = []
      this._getMerchantGoodsList({
        curpage: 1,
        audit_status: this.activeName
      })
      this.pagination.currentPage = 1
      this._tabsRecord()
    },
    /**
     * 获取列表
     * @param params
     * @private
     */
    _getMerchantGoodsList(params) {
      this.api.getMerchantGoodsList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    }
  }
}
</script>
